import React, { useState, useRef } from "react";
import env from "@beam-australia/react-env";
import { atom, useAtom } from "jotai";
import { forgotPasswordState } from "../../../states/forgotPasswordState";
import { loadingState } from "../../../states/loadingState";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { classNames } from "primereact/utils";
import useApi from "../../../hooks/useApi";
import "./resetPassword.css";
import { Toast } from "primereact/toast";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const ResetPasswordStep3_recovery = ({ settings }) => {
  const { t } = useTranslation();
  const api = useApi();
  const [isLoading, setIsLoading] = useAtom(loadingState);
  const [captchaToken, setCaptchaToken] = useState(null);
  const navigate = useNavigate();
  const toast = useRef(null);
  const [key, setKey] = useState();

  const setForgotPassword = useAtom(forgotPasswordState);
  const forgotPassword = useAtom(forgotPasswordState);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      newPassword: "",
    },
  });

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSubmit = async (data) => {
    if (!executeRecaptcha) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "reCAPTCHA no disponible",
        life: 3000,
      });
      return;
    }

    const token = await executeRecaptcha("submit");

    if (!token) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error al generar el reCAPTCHA",
        life: 3000,
      });
      return;
    }

    setCaptchaToken(token);
    setIsLoading(true);

    try {
      data.email = forgotPassword.email;
      data.key = forgotPassword.key;
      const response = await api.post(`${env("API_URL")}/base/auth/recovery`, {
        ...data,
        captchaToken: token,
      });

      toast.current.show({
        severity: "success",
        summary: t("forms.messages.titles.success"),
        detail: t("forms.messages.operation.success"),
        life: 3000,
      });

      setForgotPassword((prevState) => ({
        ...prevState,
        key: key,
      }));

      navigate("/");
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: t("forms.messages.titles.error"),
        detail: t("forms.messages.operation.error"),
        life: 3000,
      });

      setIsLoading(false);
    }
  };

  const getFormErrorMessage = (error) => {
    return error && <small className="p-error">{error.message}</small>;
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="flex justify-content-center align-items-center h-screen">
        <div className="flex flex-column  justify-content-center align-items-center p-4 border-1 border-400">
          <div>
            <p className="inputHelpText inputHelpText_small p-4">
              Ingresa tu nueva contraseña de seis o más caracteres.
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <div className="field">
              <Controller
                name="newPassword"
                control={control}
                rules={{
                  required: t("forms.validation.required", {
                    entity: t("entities.administrators.newPassword"),
                  }),
                  minLength: {
                    value: 6,
                    message: t("forms.validation.minLength", {
                      entity: t("entities.administrators.newPassword"),
                      maxLength: 6,
                    }),
                  },
                  maxLength: {
                    value: 30,
                    message: t("forms.validation.maxLength", {
                      entity: t("entities.administrators.newPassword"),
                      maxLength: 30,
                    }),
                  },
                }}
                render={({ field, fieldState }) => (
                  <React.Fragment>
                    <div className="flex justify-content-between">
                      <label htmlFor="newPassword">
                        {t("entities.administrators.newPassword")}
                      </label>
                      <div>{getFormErrorMessage(errors.newPassword)}</div>
                    </div>
                    <div className="form-crud">
                      <div className="p-inputgroup">
                        <span className="p-inputgroup-addon">
                          <i className="pi pi-key"></i>
                        </span>
                        <span className="p-float-label">
                          <Password
                            toggleMask
                            id="newPassword"
                            {...field}
                            inputRef={field.ref}
                            className={classNames({
                              "p-invalid": fieldState.error,
                            })}
                            feedback={false}
                          />
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              />
            </div>

            <Button
              label={t("Modificar contraseña")}
              className="button_big"
              loading={isLoading}
            />

            <p
              className="inputHelpText inputHelpText_small"
              style={{ textAlign: "center", paddingTop: "20px" }}
            >
              Textum es un servicio exclusivo para el personal de nuestras
              empresas asociadas.
            </p>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ResetPasswordStep3_recovery;
